import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogPostLayoutInterface } from 'common/types/entities/blog-post-layout-body-interface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'

export function migrateBlogPostLayoutBody(entity: OldEntityInterface) {
  const blogPostLayoutBody: BlogPostLayoutInterface =
    {} as BlogPostLayoutInterface

  blogPostLayoutBody.id = entity.id
  blogPostLayoutBody.type = EntityTypeEnum.BlogPostLayoutBody
  blogPostLayoutBody.childIds = entity.childIds || []

  blogPostLayoutBody.htmlAttrId = entity.options.attrId
  if (entity.isReadOnly !== undefined) {
    blogPostLayoutBody.isReadOnly = entity.isReadOnly
  }
  return blogPostLayoutBody
}
